// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,optimize_code_size,server_grpc1,long_type_number
// @generated from protobuf file "aware_proto/proto/Insights.proto" (package "aware", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Person } from "./Person";
import { Event } from "./Event";
import { RestaurantRecommendationList } from "./ComputerEvents";
import { UserActivityStatistics } from "./Event";
import { Place } from "./Location";
import { Timestamp } from "../../google/protobuf/timestamp";
// @generated message type with reflection information, may provide speed optimized methods
class FoodAndDrinkInsights$Type extends MessageType {
    constructor() {
        super("aware.FoodAndDrinkInsights", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "analysis_interval_start", kind: "message", T: () => Timestamp },
            { no: 3, name: "analysis_interval_end", kind: "message", T: () => Timestamp },
            { no: 4, name: "generated_stamp", kind: "message", T: () => Timestamp },
            { no: 5, name: "visited_food_and_drink_places", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Place },
            { no: 6, name: "place_statistics", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => UserActivityStatistics } },
            { no: 7, name: "eating_activity_statistics", kind: "message", T: () => UserActivityStatistics },
            { no: 8, name: "restaurant_recommendations", kind: "message", T: () => RestaurantRecommendationList }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.FoodAndDrinkInsights
 */
export const FoodAndDrinkInsights = new FoodAndDrinkInsights$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonMeetingRecommendation$Type extends MessageType {
    constructor() {
        super("aware.PersonMeetingRecommendation", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "person_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "time_last_seen", kind: "message", T: () => Timestamp },
            { no: 4, name: "time_since_seen_days", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "observed_meeting_interval_days", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "meeting_due_score", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "restaurant_recommendations", kind: "message", T: () => RestaurantRecommendationList },
            { no: 100, name: "last_event", kind: "message", T: () => Event }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.PersonMeetingRecommendation
 */
export const PersonMeetingRecommendation = new PersonMeetingRecommendation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PersonInsights$Type extends MessageType {
    constructor() {
        super("aware.PersonInsights", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "analysis_interval_start", kind: "message", T: () => Timestamp },
            { no: 3, name: "analysis_interval_end", kind: "message", T: () => Timestamp },
            { no: 4, name: "generated_stamp", kind: "message", T: () => Timestamp },
            { no: 5, name: "people_met", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Person },
            { no: 6, name: "person_statistics", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => UserActivityStatistics } },
            { no: 7, name: "social_meeting_activity_statistics", kind: "message", T: () => UserActivityStatistics },
            { no: 8, name: "work_meeting_activity_statistics", kind: "message", T: () => UserActivityStatistics },
            { no: 9, name: "meeting_recommendations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PersonMeetingRecommendation },
            { no: 100, name: "referenced_places", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Place } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.PersonInsights
 */
export const PersonInsights = new PersonInsights$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkoutInsights$Type extends MessageType {
    constructor() {
        super("aware.WorkoutInsights", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "analysis_interval_start", kind: "message", T: () => Timestamp },
            { no: 3, name: "analysis_interval_end", kind: "message", T: () => Timestamp },
            { no: 4, name: "generated_stamp", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.WorkoutInsights
 */
export const WorkoutInsights = new WorkoutInsights$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityInsights$Type extends MessageType {
    constructor() {
        super("aware.ActivityInsights", [
            { no: 1, name: "user_uid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "food_and_drink", kind: "message", T: () => FoodAndDrinkInsights },
            { no: 3, name: "person_insights", kind: "message", T: () => PersonInsights }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message aware.ActivityInsights
 */
export const ActivityInsights = new ActivityInsights$Type();
